import getRandomNumberBetween from './get-random-number-between';
import generatePositionFromTime from './generate-position-from-time';

export function positionBetween(before, after) {
  const hasBefore = typeof before === 'number' && !isNaN(before);
  const hasAfter = typeof after === 'number' && !isNaN(after);

  if (!hasBefore && !hasAfter) return generatePositionFromTime();
  if (!hasBefore) return after - getRandomNumberBetween(100, 200);
  if (!hasAfter) return before + getRandomNumberBetween(100, 200);
  return (before + after) / 2;
}

// The position to give a record appended to the end of `records`.
//
// Records that were created but have not saved yet have no id, and no position
// worth counting — a list is not necessarily in position order either (an async
// relationship arrives in whatever order the API returned), so this takes the
// highest position rather than the last entry's.
export function nextPositionAfter(records) {
  const positions = records
    .slice()
    .filter((record) => record.id)
    .map((record) => record.position ?? 0);

  return positions.length === 0 ? 1 : Math.max(...positions) + 1;
}

export function neighborsOf(el, container, idAttribute) {
  const children = [...container.children];
  const index = children.indexOf(el);
  const beforeEl = index > 0 ? children[index - 1] : null;
  const afterEl =
    index >= 0 && index < children.length - 1 ? children[index + 1] : null;

  return {
    beforeId: beforeEl?.dataset?.[idAttribute] || null,
    afterId: afterEl?.dataset?.[idAttribute] || null,
  };
}
